module.exports = __webpack_public_path__ + "40ed3360e76cbae0677897658f175ad2.woff2";